import styled from 'styled-components';

import { InputField } from 'components/fields';
import { captionRegular, messagesRegular } from 'styles/mixins/fonts';
import { AddButton, DeleteButton } from 'components/specified-buttons';

export const Container = styled.div`
  flex: 1;
  display: flex;
  overflow-y: auto;
  overflow-x: hidden;
  flex-direction: column;
`;

export const Title = styled.p`
  ${messagesRegular};
`;

export const SwitchSubtitle = styled.p`
  ${captionRegular};
  color: ${({ theme }) => theme.colors.grey.primary.standard};
`;

export const StyledInput = styled(InputField)`
  width: 136px;
`;

export const StyledDeleteButton = styled(DeleteButton)`
  flex-shrink: 0;
  margin-top: 24px;
`;

export const StyledAddButton = styled(AddButton)`
  margin-top: 0;
`;
